import React from 'react';

import { bemBlock } from '@neptune/shared/venus-ui';

import { CopyToClipboard } from '../copy-to-clipboard/CopyToClipboard';

import './CommandFrame.less';

const block = bemBlock('command-frame');

export const CommandFrame: React.FC<{
  command: string;
  className?: string;
  transparent?: boolean;
  oneliner?: boolean;
}> = ({ command, className, transparent = false, oneliner }) => {
  if (!command) {
    return null;
  }

  return (
    <div className={block({ modifiers: { transparent }, extra: className })}>
      <div className={block({ element: 'command', modifiers: { oneliner } })}>
        {command}
        <CopyToClipboard
          className={block({ element: 'copy', modifiers: { oneliner } })}
          text={command}
        />
      </div>
    </div>
  );
};
